import React, { useEffect, useState } from 'react';

export const GEO_OPTIONS = [['todos', 'Todos'], ['sin_exclusion', 'Sin exclusión'], ['excluidos', 'Excluidos'], ['ubicacion_pendiente', 'Ubicación pendiente']];
const valid = value => GEO_OPTIONS.some(([v]) => v === value) ? value : 'todos';

export function useGeographicFilter(userId, initial) {
  const key = `xen-geografia-${userId}`;
  const [value, setValue] = useState(() => {
    try { return valid(initial || sessionStorage.getItem(key)); } catch { return 'todos'; }
  });
  useEffect(() => { sessionStorage.setItem(key, value); }, [key, value]);
  return [value, setValue];
}

export const GeographicFilter = ({ value, onChange, testId = 'filter-exclusion-geografica' }) => (
  <label className="flex flex-col gap-1 min-w-0 text-xs font-medium" data-testid={`${testId}-label`}>
    Exclusión geográfica
    <select className="input-base text-xs w-full" data-testid={testId} value={value} onChange={e => onChange(e.target.value)}>
      {GEO_OPTIONS.map(([v, label]) => <option key={v} value={v}>{label}</option>)}
    </select>
  </label>
);